var pt = {
  TABLE_HEADER_SORT_ASC: 'Ordem Crescente',
  TABLE_HEADER_SORT_DESC: 'Ordem Decrescente',
  SEARCH_PLACEHOLDER: 'Buscar',
  TABLE_HEADER_FILTER_SEARCH_PLACEHOLDER: 'Buscar',
  TABLE_HEADER_FILTER_CLEAR_ALL: 'Limpar tudo',
  TABLE_HEADER_FILTER_SEARCH_EMPTY_TABLE_TITLE: 'Nenhum resultado encontrado',
  TABLE_HEADER_FILTER_SEARCH_EMPTY_TABLE_SUBTITLE: 'Tente palavras-chave mais gerais',
  TABLE_STATE_LOADING_RESULTS: 'Carregando resultados...',
  TABLE_STATE_EMPTY_SEARCH_TITLE: 'Nenhum resultado encontrado para',
  TABLE_STATE_EMPTY_SEARCH_SUBTITLE: 'Tente novamente com um termo diferente.',
  TABLE_STATE_EMPTY_FILTER_TITLE: 'Nenhum resultado para exibir',
  TABLE_STATE_EMPTY_FILTER_SUBTITLE: 'Tente novamente com um filtro diferente',
  TABLE_STATE_EMPTY_FILTER_CTA: 'Limpar filtros',
  TABLE_HEADER_SELECT_ALL_TOOLTIP: 'Selecionar tudo',
  TABLE_HEADER_SELECTION_RESUME_COUNT: 'selecionado.',
  TABLE_HEADER_SELECTION_RESUME_COUNT_plural: 'selecionados.',
  TABLE_HEADER_SELECTION_RESUME_SELECT_ALL: 'Selecionar todos os {{count}} itens',
  TABLE_HEADER_SELECTION_RESUME_REMOVE_ALL: 'Remover seleção',
  TABLE_STATE_EMPTY_WITHOUT_FILTERS: 'Ainda não há resultados disponíveis',
  TABLE_STATE_EMPTY_WITHOUT_FILTERS_SUBTITLE: 'A tabela não tem informações para exibir',
  TABLE_STATE_ERROR_TITLE: 'Ocorreu um erro',
  TABLE_STATE_ERROR_SUBTITLE: 'Clique no botão para tentar carregar novamente.',
  TABLE_STATE_ERROR_BUTTON_LABEL: 'Repetir',
  TABLE_HEADER_ATTRIBUTES_FILTER_APPLY_BUTTON: 'Aplicar filtros',
  TABLE_HEADER_ATTRIBUTES_FILTER_SORT_BUTTON: 'Ordenar por',
  TABLE_HEADER_ATTRIBUTES_FILTER_SEARCH_PLACEHOLDER: 'Buscar atributo de usuário',
  TABLE_HEADER_ATTRIBUTES_CUSTOM_FIELDS_COUNT: 'etiquetas',
  TABLE_HEADER_ATTRIBUTES_CLEAR_ALL: 'Limpar tudo',
  TABLE_HEADER_ATTRIBUTES_ATTRIBUTE_ITEM_SHOW_ALL: 'Mostrar todos',
  TABLE_HEADER_ATTRIBUTES_EMPTY_SEARCH_TITLE: 'Nenhum resultado encontrado para',
  TABLE_HEADER_ATTRIBUTES_EMPTY_SEARCH_SUBTITLE: 'Tente novamente com um termo diferente.',
  TABLE_HEADER_ATTRIBUTES_DETAIL_BACK_BUTTON: 'Voltar',
  TABLE_HEADER_ATTRIBUTES_DETAIL_SELECT_ALL: 'Selecionar tudo',
  TABLE_HEADER_ATTRIBUTES_DETAIL_REMOVE_SELECT_ALL: 'Desmarcar todos',
  TABLE_PAGE_SIZE_SELECTOR_LABEL: 'Itens por página:'
};
export default pt;